import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Div from "@jumbo/shared/Div";
import * as yup from "yup";
import { TextField, Typography } from "@mui/material";
import { ErrorMessage, Formik } from "formik";
import { LoadingButton } from "@mui/lab";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { Axios } from "index";
import AllApis from "app/Apis/apis";
import { getAllTicket } from "app/redux/actions/Tickets";

const AddTicketModal = ({ open, onClose, selectedRow }) => {
  const [isSubmitting, setSubmitting] = useState(false);
  const type = selectedRow?.action;
  const state = selectedRow?.data;
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state?.userReducer);
  const initialValues = {
    user_id: userData?._id,
    module_type: "retailers",
    complaint: "",
  };

  const validationSchema = yup.object({
    complaint: yup.string().required("Complaint is required"),
  });

  const onUserSave = async (values) => {
    let response;
    try {
      setSubmitting(true);
      response = await Axios.post(AllApis.ticket.add, values);
      if (response?.data?.statusCode) {
        onClose(true);
        Swal.fire({
          title: "Ticket Generated",
          icon: "success",
          timer: 1000,
          showConfirmButton: false,
        });
        dispatch(getAllTicket("", "desc", "created_at", 1));
      }
    } catch (error) {
      onClose(true);
      Swal.fire({
        title: error?.response?.data.message,
        icon: "error",
        timer: 1000,
        showConfirmButton: false,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth={200}>
      <Div sx={{ display: "flex", justifyContent: "space-between" }}>
        <DialogTitle sx={{ fontWeight: "700", textTransform: "capitalize" }}>
          Create Ticket
        </DialogTitle>
      </Div>
      <DialogContent>
        <Div>
          <Formik
            validateOnChange={true}
            initialValues={initialValues}
            enableReinitialize={true}
            validationSchema={validationSchema}
            onSubmit={onUserSave}
          >
            {({ setFieldValue, values, errors, touched, handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Div>
                  <Div
                    sx={{
                      display: "flex",
                      width: "100%",
                      flexWrap: "wrap",
                      columnGap: 5,
                      rowGap: 1,
                    }}
                  >
                    <Div sx={{ width: "100%" }}>
                      <Typography variant="h5">Complaint</Typography>
                      <TextField
                        name="complaint"
                        size="small"
                        error={!!(touched.complaint && errors.complaint)}
                        value={values?.complaint}
                        fullWidth
                        multiline
                        rows={4}
                        onChange={(e) =>
                          setFieldValue("complaint", e.target.value)
                        }
                      />
                      <ErrorMessage
                        name="complaint"
                        component={"div"}
                        style={{ color: "red" }}
                      />
                    </Div>
                    <Div
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 3,
                        mt: 3,
                      }}
                    >
                      <Button
                        sx={{ width: "100px" }}
                        variant="outlined"
                        onClick={onClose}
                      >
                        Cancel
                      </Button>
                      <LoadingButton
                        variant="contained"
                        type="submit"
                        sx={{ width: "100px" }}
                        loading={isSubmitting}
                      >
                        Create
                      </LoadingButton>
                    </Div>
                  </Div>
                </Div>
              </form>
            )}
          </Formik>
        </Div>
      </DialogContent>
    </Dialog>
  );
};

export default AddTicketModal;
